import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-item" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = ["data-show"]
const _hoisted_4 = { class: "search" }
const _hoisted_5 = { class: "app-width" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  class: "form",
  "data-type": "search"
}
const _hoisted_8 = ["placeholder", "aria-label"]
const _hoisted_9 = {
  key: 0,
  class: "suggestion"
}
const _hoisted_10 = { class: "app-width" }
const _hoisted_11 = { class: "products" }
const _hoisted_12 = { class: "list" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "offertag" }
const _hoisted_15 = { class: "image" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = { class: "price" }
const _hoisted_19 = { class: "from" }
const _hoisted_20 = { class: "unit" }
const _hoisted_21 = { class: "val" }
const _hoisted_22 = {
  class: "calltoaction",
  "data-color": "greyl"
}
const _hoisted_23 = { class: "button" }
const _hoisted_24 = { class: "count" }
const _hoisted_25 = { class: "calltoaction" }
const _hoisted_26 = {
  key: 1,
  class: "suggestion no-result"
}
const _hoisted_27 = { class: "app-width" }
const _hoisted_28 = {
  class: "title mrg",
  "data-mrgb": "15"
}
const _hoisted_29 = { class: "abstract" }

import { ref, watch } from "vue";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import Axios from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBox',
  setup(__props) {

const localizer = Localizer;
const routes = (window as any).App.routes;

const isSearchVisible = ref(false);
const searchText = ref("");
const minTextLength = ref(3);
const suggestionCount = ref(0);
const debounceTimeOut = ref<any>(null);
const suggestionIndex = ref(-1);
const isSuggestionNotFound = ref(false);
const isLoading = ref(false);
const suggestions = ref<any[]>([]);

watch(searchText, (newText: string) => {
    debounceGetSuggestions(newText, 500);
});

function showSearch() {
    isSearchVisible.value = !isSearchVisible.value;
}

function showAll() {
    GTagHelper.sendEvent("view_search_results", "header_search", "all_detail");

    window.location.href = routes.Search_List + "?searchtext=" + searchText.value;
}

function sendEvent() {
    GTagHelper.sendEvent("view_search_results", "header_search", "product");
}

function debounceGetSuggestions(searchtext: any, delay: number) {
    clearTimeout(debounceTimeOut.value);

    debounceTimeOut.value = setTimeout(async function () {
        if (searchtext != null && searchtext.length >= 3) {
            await getSuggestions(searchtext);
        } else if (searchtext === null || searchtext.length === 0) {
            clearSearch();
        }
    }, delay);
}

function checkMinTextLength(text: string): boolean {
    return text && text.length >= minTextLength.value;
}

async function getSuggestions(searchtext: string) {
    isLoading.value = true;

    suggestions.value = [];

    try {
        const response = (await Axios.post(routes.Search_GetSuggestions, { searchtext: searchtext })).data;

        suggestions.value = response;

        isSuggestionNotFound.value = suggestions.value.length === 0;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            suggestions.value = [];
        }
    }

    isLoading.value = false;
}

function resetSuggestionValues() {
    suggestionIndex.value = -1;
    suggestions.value = [];
}

function suggestionMoveDown() {
    if (suggestions.value.length !== 0 && suggestionIndex.value < suggestions.value.length - 1) {
        suggestionIndex.value++;
    }
}

function suggestionMoveUp() {
    if (suggestions.value.length !== 0 && suggestionIndex.value > 0) {
        suggestionIndex.value--;
    }
}

function setSuggestion() {
    if (suggestionIndex.value !== -1) {
        const suggestion = suggestions.value[suggestionIndex.value];
        window.location.href = suggestion.linkUrl;
    }
}

function clearSearch() {
    searchText.value = "";
    suggestions.value = [];
    isSuggestionNotFound.value = false;
}

function searchList() {
    if (searchText.value?.length > 2) {
        window.location.href = `${routes.Support_SearchList}?searchtext=${searchText.value}`;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button",
        "data-type": "open-search",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showSearch())),
        "aria-label": "Cerca"
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "icon fastic-search" }, null, -1)
      ]))])
    ]),
    _createElementVNode("div", {
      class: "app-search",
      "data-show": isSearchVisible.value
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showSearch())),
            "aria-label": "Chiudi ricerca"
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("span", { class: "icon fastic-close" }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(localizer).get("App.Common.SearchInTechnicalCeramic")), 1),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchText).value = $event)),
              class: "textbox textbox-search",
              placeholder: _unref(localizer).get('App.Common.Search_Placeholder'),
              type: "text",
              "aria-label": _unref(localizer).get('App.Common.Search_Placeholder')
            }, null, 8, _hoisted_8), [
              [_vModelText, searchText.value]
            ]),
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showAll())),
              "aria-label": "Mostra tutti i risultati"
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("span", { class: "fastic-search icon" }, null, -1)
            ]))])
          ])
        ])
      ]),
      (suggestions.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (suggestion) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: suggestion.linkUrl,
                      class: "item",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (sendEvent()))
                    }, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(localizer).get("App.Catalogue.Offer")), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: suggestion.imageUrl,
                          width: "303",
                          height: "303",
                          loading: "lazy"
                        }, null, 8, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(suggestion.title), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(localizer).get("App.Common.From")), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(suggestion.price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(localizer).get("Catalogue.Common.FindOutMore")), 1)
                      ])
                    ], 8, _hoisted_13))
                  }), 256))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showAll())),
                    class: "button"
                  }, _toDisplayString(_unref(localizer).get("App.Common.Search_ShowAll")), 1)
                ])
              ])
            ])
          ]))
        : (suggestions.value.length == 0 && searchText.value != '' && searchText.value.length > 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(localizer).get("App.Common.Search_NotFound_Title")), 1),
                _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(localizer).get("App.Common.Search_NotFound_Abstract")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
    ], 8, _hoisted_3)
  ]))
}
}

})